<template>
  <SvgIcon :name="prefixedName" :class="$attrs.class" class="ui-icon" />
</template>

<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  title: { type: String, default: null },
  desc: { type: String, default: null },
  solid: Boolean,
  outline: Boolean,
})
const prefixedName = computed(
  () =>
    `${props.solid ? 'solid/' : props.outline ? 'outline/' : ''}${props.name}`,
)
</script>
